import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Fuel, Building2, Cpu, Wallet, ArrowRight, CheckCircle, MapPin, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Subsidiaries = () => {
  const subsidiaries = [
    {
      id: 'kip-energy',
      name: 'KIP ENERGY',
      tagline: "L'Énergie qui Propulse Votre Quotidien",
      logo: 'https://customer-assets.emergentagent.com/job_ekip-showcase/artifacts/590yfomx_Logo%20KIP%20ENERGY.png',
      icon: Fuel,
      color: '#FF6600',
      description: 'Distributeur exclusif de la marque Wayne en Côte d\'Ivoire, offrant produits pétroliers et services énergétiques.',
      activities: [
        'Distribution Wayne (carburants, lubrifiants, consommables automobiles)',
        'Réseau de stations-services modernes avec boutiques intégrées',
        'Infrastructures pétrolières (stockage stratégique)',
        'Trading pétrolier (brut et produits raffinés)'
      ],
      projects: [
        {
          title: 'Partenariat EPC+F Wayne-Kip Energy',
          value: '120M USD',
          details: [
            'Construction de 140 000 m³ de capacités de stockage pétrolier',
            '3 sites stratégiques (Abidjan, Yamoussoukro, San-Pédro)',
            'Contribution à la sécurité énergétique nationale'
          ]
        }
      ],
      vision: 'Devenir un acteur intégré de la chaîne de valeur énergétique en Côte d\'Ivoire, du midstream au downstream, tout en contribuant à la souveraineté énergétique nationale.',
      website: 'https://www.kipenergy.ci'
    },
    {
      id: 'kidh',
      name: 'KIPYZ DESIGN & HOUSES',
      tagline: "L'Habitat Moderne en Co-Création",
      logo: 'https://customer-assets.emergentagent.com/job_a6c32c3a-8d7a-49cd-8ea0-9f0781a3c364/artifacts/2re5u10q_Logo%20Filiale%20KIDH.png',
      icon: Building2,
      color: '#00A651',
      description: 'Développement de projets immobiliers résidentiels innovants en Côte d\'Ivoire, avec une approche de co-création pour personnaliser l\'espace de vie.',
      activities: [
        'Cités résidentielles intégrées (services, commerces)',
        'Immeubles de bureaux modernes et connectés',
        'Centres commerciaux de quartier',
        'Espaces de vie communautaires (parcs, espaces verts, infrastructures sportives)'
      ],
      portfolio: [
        { name: 'Bingerville', size: '60 ha', description: 'Cités résidentielles modernes, proximité Autoroute du Nord' },
        { name: 'Angré', size: '10 ha', description: 'Zone commerciale stratégique, immeubles de standing' },
        { name: 'Songon', size: '35 ha', description: 'Propriétés au bord du lac, résidences haut de gamme' },
        { name: 'Sassandra', size: '50 ha', description: 'Complexe touristique intégré, Golf 18 trous, hôtels' },
        { name: 'Yamoussoukro', size: '24 ha', description: 'Campus universitaire INPHB, résidences étudiantes' }
      ],
      vision: 'Créer des habitats qui ressemblent aux clients grâce à la co-création, en impliquant les clients dès la conception.',
      website: 'https://www.kidh.ci'
    },
    {
      id: 'ekiptech',
      name: 'EKIPTECH',
      tagline: "L'Intelligence qui Connecte Votre Vie",
      logo: 'https://customer-assets.emergentagent.com/job_a6c32c3a-8d7a-49cd-8ea0-9f0781a3c364/artifacts/3p5tqo9a_Logo%20Filiale%20Ekiptech.png',
      icon: Cpu,
      color: '#003366',
      description: 'Fourniture de solutions technologiques pour l\'habitat moderne et la mobilité connectée, distribution d\'équipements de pointe et développement de solutions IoT.',
      activities: [
        'Distribution Zebra Technologies (solutions d\'identification et de traçabilité)',
        'Solutions domotiques (maison intelligente)',
        'Appareils IoT (habitat et mobilité)',
        'Boutiques intégrées dans les stations-services Wayne'
      ],
      solutions: [
        'Domotique résidentielle (contrôle éclairage, climatisation, sécurité)',
        'Sécurité connectée (caméras IP, alarmes intelligentes, contrôle d\'accès)',
        'Énergie intelligente (optimisation consommation, panneaux solaires connectés)',
        'Mobilité connectée (trackers GPS, systèmes de diagnostic automobile)'
      ],
      vision: 'Équiper chaque foyer et chaque véhicule ivoirien avec des technologies qui simplifient et enrichissent le quotidien.',
      website: 'https://www.ekiptech.com'
    },
    {
      id: 'kipay',
      name: 'KIPAY',
      tagline: 'La Fluidité au Cœur de Votre Écosystème',
      logo: 'https://customer-assets.emergentagent.com/job_ekip-showcase/artifacts/xwwmtwz6_Logo%20Filiale%20Kipay.png',
      icon: Wallet,
      color: '#FFB81C',
      description: 'Développement de solutions de paiement innovantes et d\'un programme de fidélisation multi-enseignes unifiant l\'expérience client à travers l\'écosystème EKIP.',
      activities: [
        'Cartes bancaires co-brandées',
        'Programme de fidélité intégré (points cumulables chez Wayne, EKIPTECH, KIDH)',
        'Wallet digital (paiements mobiles sécurisés)',
        'Solutions de financement (facilités de paiement habitat/énergie)'
      ],
      advantages: [
        'Réductions carburants',
        'Cashback sur produits tech',
        'Avantages immobiliers exclusifs',
        'Programme de parrainage'
      ],
      vision: 'Devenir la solution de paiement préférée des Ivoiriens en créant un écosystème financier fluide, sécurisé et avantageux.',
      status: 'En développement',
      website: 'https://www.kipay.net'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#003366] to-[#004080]">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Nos Filiales
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Quatre entités compémentaires qui forment un écosystème intégré unique en Afrique de l'Ouest
          </p>
        </div>
      </section>

      {/* Subsidiaries Details */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto space-y-24">
          {subsidiaries.map((sub, index) => {
            const Icon = sub.icon;
            const isEven = index % 2 === 0;
            
            return (
              <div key={sub.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-start ${!isEven ? 'lg:flex-row-reverse' : ''}`}>
                {/* Content */}
                <div className={isEven ? '' : 'lg:order-2'}>
                  <div className="flex items-center space-x-4 mb-6">
                    <div 
                      className="w-16 h-16 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: `${sub.color}15` }}
                    >
                      <Icon style={{ color: sub.color }} size={32} />
                    </div>
                    <img src={sub.logo} alt={sub.name} className="h-20 w-auto" />
                  </div>
                  
                  <h2 className="text-3xl md:text-4xl font-bold text-[#003366] mb-3">
                    {sub.name}
                  </h2>
                  <p className="text-xl font-semibold mb-6" style={{ color: sub.color }}>
                    {sub.tagline}
                  </p>
                  {sub.status && (
                    <span className="inline-block bg-[#FFB81C] text-white px-4 py-1 rounded-full text-sm font-semibold mb-6">
                      {sub.status}
                    </span>
                  )}
                  <p className="text-lg text-gray-700 leading-relaxed mb-8">
                    {sub.description}
                  </p>

                  {/* Activities or Solutions */}
                  <div className="mb-8">
                    <h3 className="text-xl font-bold text-[#003366] mb-4">
                      {sub.solutions ? 'Nos Solutions' : 'Nos Activités'}
                    </h3>
                    <ul className="space-y-3">
                      {(sub.solutions || sub.activities).map((item, i) => (
                        <li key={i} className="flex items-start space-x-3">
                          <CheckCircle className="flex-shrink-0 mt-1" style={{ color: sub.color }} size={20} />
                          <span className="text-gray-700">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Vision */}
                  <Card className="border-2" style={{ borderColor: sub.color }}>
                    <CardContent className="p-6">
                      <h3 className="text-lg font-bold text-[#003366] mb-3">Notre Vision</h3>
                      <p className="text-gray-700 leading-relaxed mb-4">{sub.vision}</p>
                      {sub.website && (
                        <a 
                          href={sub.website} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="inline-flex items-center text-sm font-semibold hover:underline transition-colors"
                          style={{ color: sub.color }}
                        >
                          Pour plus de détails, visiter notre site web
                          <ArrowRight className="ml-2" size={16} />
                        </a>
                      )}
                    </CardContent>
                  </Card>
                </div>

                {/* Projects/Portfolio/Advantages Card */}
                <div className={isEven ? '' : 'lg:order-1'}>
                  <Card className="shadow-xl border-0">
                    <CardContent className="p-8">
                      {sub.projects && (
                        <div>
                          <h3 className="text-2xl font-bold text-[#003366] mb-6">Projets Majeurs</h3>
                          {sub.projects.map((project, i) => (
                            <div key={i} className="mb-6">
                              <div className="flex items-center justify-between mb-4">
                                <h4 className="text-lg font-bold text-[#003366]">{project.title}</h4>
                                <span className="text-2xl font-bold" style={{ color: sub.color }}>{project.value}</span>
                              </div>
                              <ul className="space-y-2">
                                {project.details.map((detail, j) => (
                                  <li key={j} className="flex items-start space-x-2">
                                    <span className="text-[#00A651] mt-1">•</span>
                                    <span className="text-gray-600 text-sm">{detail}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                      )}
                      
                      {sub.portfolio && (
                        <div>
                          <h3 className="text-2xl font-bold text-[#003366] mb-2">Portfolio de Terrains</h3>
                          <p className="text-3xl font-bold text-[#00A651] mb-6">179+ Hectares</p>
                          <div className="space-y-4">
                            {sub.portfolio.map((site, i) => (
                              <div key={i} className="border-l-4 pl-4" style={{ borderColor: sub.color }}>
                                <div className="flex items-center space-x-2 mb-1">
                                  <MapPin size={16} style={{ color: sub.color }} />
                                  <h4 className="font-bold text-[#003366]">{site.name}</h4>
                                  <span className="text-sm font-semibold" style={{ color: sub.color }}>({site.size})</span>
                                </div>
                                <p className="text-sm text-gray-600">{site.description}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      
                      {sub.advantages && (
                        <div>
                          <h3 className="text-2xl font-bold text-[#003366] mb-6">Avantages Exclusifs</h3>
                          <div className="grid grid-cols-2 gap-4">
                            {sub.advantages.map((advantage, i) => (
                              <div key={i} className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-lg border border-gray-200">
                                <CheckCircle style={{ color: sub.color }} size={20} className="mb-2" />
                                <p className="text-sm font-semibold text-gray-700">{advantage}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </CardContent>
                  </Card>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#00A651] to-[#008a43]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Intéressé par Nos Solutions ?
          </h2>
          <p className="text-xl text-white/90 mb-10">
            Découvrez comment nos filiales peuvent répondre à vos besoins
          </p>
          <Button 
            asChild
            size="lg"
            className="bg-white text-[#00A651] hover:bg-gray-100 text-lg px-10 py-6"
          >
            <Link to="/contact">
              Contactez-nous
              <ArrowRight className="ml-2" size={20} />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
};